import { Component, OnInit, Input,CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractValueAccessor } from '../../../comum/controls/AbstractValueAccessor';
import { EditorModule } from '@tinymce/tinymce-angular';

@Component({
    selector: 'app-editor',
    templateUrl: './editor.html',
    styleUrls: ['./editor.css']
})

export class AppEditorComponent extends AbstractValueAccessor implements OnInit  {
   // @ViewChild('editor')
   // editor: EditorComponent = new EditorComponent();

  ngOnInit(){
  }


}




@NgModule({
    declarations: [AppEditorComponent],
    imports: [ CommonModule, EditorModule ],
    exports: [],
    providers: [],
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
})
export class AppEditorModule {}
